import React from 'react';
import PropTypes from 'prop-types';

export const EmptyCell = ({ cellProps }) => (
    <td
        {...cellProps}
        className="stats-table__cell stats-table__cell--empty js-player-stats-empty-cell"
    />
);

EmptyCell.propTypes = {
    cellProps: PropTypes.object.isRequired
};
